import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function initNavPanel() {
  const navToggle = document.getElementById('nav-toggle');
  const navPanel = document.querySelector('.mobileNav');
  const toggleLabel = document.querySelector('.navToggle__icon');
  const body = document.body;

  let toggleChecked = false;
  let scrollPosition = 0;
  let preservedClasses = [];
  let scrollTriggers = [];

  // // Function to prevent scroll
  // function preventScroll() {
  //   scrollPosition = window.pageYOffset;
    
  //   // Preserve current header classes before fixing position
  //   preservedClasses = Array.from(body.classList).filter(cls => 
  //     cls.startsWith('header-')
  //   );
    
  //   // Temporarily disable all ScrollTriggers
  //   scrollTriggers = ScrollTrigger.getAll();
  //   scrollTriggers.forEach(trigger => {
  //     trigger.disable();
  //   });
    
  //   body.style.position = 'fixed';
  //   body.style.top = `-${scrollPosition}px`;
  //   body.style.width = '100%';
    
  //   // Ensure preserved classes stay applied
  //   preservedClasses.forEach(cls => {
  //     body.classList.add(cls);
  //   });
  // }

  // // Function to restore scroll
  // function restoreScroll() {
  //   body.style.position = '';
  //   body.style.top = '';
  //   body.style.width = '';
    
  //   // Re-enable ScrollTriggers
  //   scrollTriggers.forEach(trigger => {
  //     trigger.enable();
  //   });
    
  //   // Restore scroll position
  //   window.scrollTo(0, scrollPosition);
    
  //   // Force ScrollTrigger to refresh and recalculate
  //   setTimeout(() => {
  //     ScrollTrigger.refresh();
  //   }, 10);
  // }

  // Track menu state
  if (navToggle) {
    navToggle.addEventListener('change', function() {
      toggleChecked = this.checked;
    });
    // Initialize toggleChecked state
    toggleChecked = navToggle.checked;
  }

  // navToggle.addEventListener('change', function() {
  //   toggleChecked = this.checked;
    
  //   if (toggleChecked) {
  //     preventScroll();
  //   } else {
  //     restoreScroll();
  //   }
  // });
  
  if (navToggle && navPanel) {
    document.addEventListener('click', function(event) {
      if (toggleChecked) {
        if (!navPanel.contains(event.target) && !toggleLabel.contains(event.target)) {
          navToggle.checked = false;
          toggleChecked = false;
          // restoreScroll();
        }
      }
    });

    // Close menu when hash link is clicked in mobile menu (same page)
    navPanel.addEventListener('click', function(event) {
      const link = event.target.closest('a[href*="#"]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href || !href.includes('#')) return;

      // Skip empty hash links
      if (href === '#' || href === '#/') return;

      try {
        // Handle both relative hash links (#section) and full URLs
        let linkUrl;
        if (href.startsWith('#')) {
          // Relative hash link - same page
          const hash = href.substring(1);
          if (!hash) return; // Empty hash, skip
          
          // It's definitely the same page
          // Small delay to allow smooth scroll to start
          setTimeout(() => {
            navToggle.checked = false;
            toggleChecked = false;
          }, 100);
          return;
        } else {
          // Full URL with hash
          linkUrl = new URL(href, window.location.origin);
          const currentUrl = new URL(window.location.href);

          // Check if it's the same page (same pathname)
          const isSamePage = linkUrl.pathname === currentUrl.pathname || 
                            linkUrl.pathname + '/' === currentUrl.pathname || 
                            currentUrl.pathname === linkUrl.pathname + '/';

          // If it's a hash link on the same page, close the menu
          if (isSamePage && linkUrl.hash && linkUrl.hash !== '#') {
            // Small delay to allow smooth scroll to start
            setTimeout(() => {
              navToggle.checked = false;
              toggleChecked = false;
            }, 100);
          }
        }
      } catch (error) {
        // If URL parsing fails, ignore
        return;
      }
    });
  }

  // Initialize mobile dropdowns
  function initMobileDropDowns() {
    const menuItemsWithChildren = document.querySelectorAll('.mobileNav .menu-item-has-children');
    
    menuItemsWithChildren.forEach(item => {
      const submenu = item.querySelector('.sub-menu');
      const caret = item.querySelector('.mobile-dropdown-caret');
      
      if (submenu) {
        item.addEventListener('click', function(e) {
          // Only handle clicks on the parent item itself, not child items
          const parentLink = item.querySelector('a');
          const clickedLink = e.target.closest('a');
          
          if (clickedLink === parentLink) {
            e.preventDefault();
            e.stopPropagation();
            
            const isOpen = item.classList.contains('open');
            
            if (isOpen) {
              // Close submenu
              submenu.style.maxHeight = '0';
              item.classList.remove('open');
              
              // Remove rotate class from caret
              if (caret) {
                caret.classList.remove('rotated');
                caret.setAttribute('aria-expanded', 'false');
              }
            } else {
              // Open submenu
              submenu.style.maxHeight = submenu.scrollHeight + 'px';
              item.classList.add('open');
              
              // Add rotate class to caret
              if (caret) {
                caret.classList.add('rotated');
                caret.setAttribute('aria-expanded', 'true');
              }
            }
          }
        });
      }
    });
  }

  initMobileDropDowns();
}
